import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination as SwiperPagination } from "swiper/modules";
import { useNavigate, useParams } from "react-router-dom";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function PhotoNewsSection() {
  const navigate = useNavigate();

  const { section, id, albumId } = useParams();

  const [albums, setAlbums] = useState([]);
  const [loading, setLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [activeAlbum, setActiveAlbum] = useState(null);

  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    total: 0,
    per_page: 12,
  });

  const truncate = (text, maxLength) => {
    if (!text) return "";

    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) {
      return {
        month: "N/A",
        day: "--",
        year: "----",
      };
    }

    const date = new Date(dateStr);

    return {
      month: date
        .toLocaleString("default", {
          month: "short",
        })
        .toUpperCase(),
      day: date.getDate(),
      year: date.getFullYear(),
    };
  };

  const loadAlbums = async (page = 1) => {
    try {
      setLoading(true);
      
      const perPage = section === "Photo Gallery" && id === '12' ? 12 : 3;

      const response = await axios.get(
        `${BASE_URL}galdata?page=${page}&per_page=${perPage}`,
      );

      setAlbums(response?.data?.allData || []);

      setPagination(
        response?.data?.pagination || {
          current_page: 1,
          last_page: 1,
          total: 0,
          per_page: perPage,
        },
      );
    } catch (error) {
      console.error("Gallery load failed:", error);

      setAlbums([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (section !== "Home" && section !== undefined) {
      const randomStartPage = Math.floor(Math.random() * 5) + 1;

      loadAlbums(randomStartPage);
    } else {
      loadAlbums(1);
    }
  }, [section, id]);

  useEffect(() => {
    if (!albumId) return;

    const loadAlbum = async () => {
      try {
        const response = await axios.get(`${BASE_URL}galdata/${albumId}`);

        const album = response.data.album;

        setActiveAlbum({
          trackerf: album.trackerf,

          galleryTithle: album.galleryTithle,

          caption: album.caption,

          datesd: album.datesd,

          images: album.photos || [],
        });

        setShowModal(true);
      } catch (error) {
        console.log(error);
      }
    };

    loadAlbum();
  }, [albumId]);

  const goToPage = (page) => {
    if (
      page >= 1 &&
      page <= pagination.last_page &&
      page !== pagination.current_page
    ) {
      loadAlbums(page);

      // window.scrollTo({
      //   top: 0,
      //   behavior: "smooth",
      // });
    }
  };

  const handleOpenAlbum = (album) => {
    navigate(`/Photo Gallery/${id}/album/${album.trackerf}`);

    setActiveAlbum({
      trackerf: album.trackerf,
      galleryTithle: album.galleryTithle,
      caption: album.caption,
      datesd: album.datesd,
      images: album.photos || [],
    });

    setShowModal(true);
  };

  if (!loading && albums.length === 0) {
    return null;
  }

  return (
    <section
      id="photo-news"
      className="photo-news section"
      aria-label="Photo Gallery"
    >
      <div className="container section-title" data-aos="fade-up">
        <h2>PHOTOS NEWS</h2>

        <p>
          <span>Snapshots from </span>

          <span className="description-title">the Frontlines</span>
        </p>
      </div>

      <div className="container">
        <div className="row gy-4">
          {albums.map((album) => {
            const { month, day, year } = formatDate(album.datesd);
            return (
              <div className="col-lg-4 col-md-6" key={album.trackerf}>
                <div
                  className="card h-100 shadow-sm border-0 cursor-pointer"
                  onClick={() => handleOpenAlbum(album)}
                >
                  <div className="position-relative mb-2">
                    <img
                      loading="lazy"
                      decoding="async"
                      src={
                        album.pic
                          ? `${BACKEND_URL}upload/${album.pic}`
                          : `${BACKEND_URL}upload/general_images/no_camera-photo.png`
                      }
                      alt={album.galleryTithle || "Gallery Image"}
                      className="card-img-top rounded-0"
                      style={{
                        objectFit: "cover",
                        height: "300px",
                      }}
                    />

                    <div className="vertical-date-badge">
                      <div className="date-part">{month}</div>

                      <div className="date-divider">—</div>

                      <div className="date-part vertical-formatDate">{day}</div>

                      <div className="date-divider">—</div>

                      <div className="date-part">{year}</div>
                    </div>
                  </div>

                  <div className="card-body d-flex flex-column btn-iceberg">
                    <h3
                      className="card-title text-uppercase"
                      style={{
                        lineHeight: "1.3",
                        fontSize: "1.1em",
                      }}
                    >
                      {truncate(album.galleryTithle, 100)}
                    </h3>

                    <small className="text-end">
                      {album.photo_count ? album.photo_count : 0} Photos
                    </small>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* PAGINATION */}
        <div className="d-flex justify-content-between align-items-center mt-5">
          <div>
            Page {pagination.current_page} of {pagination.last_page}
          </div>

          <div className="btn-group">
            <button
              className="btn btn-dark"
              onClick={() => goToPage(1)}
              disabled={pagination.current_page === 1}
            >
              « First
            </button>

            <button
              className="btn btn-dark"
              onClick={() => goToPage(pagination.current_page - 1)}
              disabled={pagination.current_page === 1}
            >
              ‹ Prev
            </button>

            <button
              className="btn btn-dark"
              onClick={() => goToPage(pagination.current_page + 1)}
              disabled={pagination.current_page === pagination.last_page}
            >
              Next ›
            </button>

            <button
              className="btn btn-dark"
              onClick={() => goToPage(pagination.last_page)}
              disabled={pagination.current_page === pagination.last_page}
            >
              Last »
            </button>
          </div>
        </div>
      </div>

      {/* MODAL */}
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);

          navigate(`/Photo Gallery/${id}`);
        }}
        size="lg"
        centered
      >
        <Modal.Body className="p-0 position-relative">
          {activeAlbum && (
            <>
              <div
                className="w-100 px-4 py-3 bg-success text-white position-sticky top-0"
                style={{
                  zIndex: 1000,
                }}
              >
                <h3
                  className="card-title text-capitalize"
                  style={{
                    lineHeight: "1.3",
                    fontSize: "1.1em",
                  }}
                >
                  {activeAlbum.galleryTithle}
                </h3>

                <div className="small">
                  {formatDate(activeAlbum.datesd).month}{" "}
                  {formatDate(activeAlbum.datesd).day},{" "}
                  {formatDate(activeAlbum.datesd).year}
                </div>

                {activeAlbum.caption && (
                  <p className="mb-0 small">
                    <em>{activeAlbum.caption}</em>
                  </p>
                )}
                <button
                  className="btn btn-light btn-sm mt-2"
                  onClick={() => {
                    window.open(
                      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`,
                      "_blank",
                    );
                  }}
                >
                  Share on Facebook
                </button>
              </div>

              <Swiper
                modules={[Navigation, SwiperPagination]}
                navigation
                pagination={{ clickable: true }}
                loop={(activeAlbum?.images?.length || 0) > 1}
              >
                {activeAlbum.images?.map((image, index) => (
                  <SwiperSlide key={index}>
                    <img
                      loading="lazy"
                      decoding="async"
                      src={`${BACKEND_URL}upload/${image.pic}`}
                      alt="Gallery"
                      className="img-fluid w-100"
                      style={{
                        maxHeight: "75vh",
                        objectFit: "contain",
                      }}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </>
          )}
        </Modal.Body>
      </Modal>
    </section>
  );
}

export default React.memo(PhotoNewsSection);
